import React from "react";
import I18nMessage from "../../i18n/I18nMessage";

export default () => (
    <div className="toast-head">
        <I18nMessage id="fw.authentication.changePassword.changed"/>
    </div>
);